import metaValue from './metaValue';

const post = (url, body = {}) =>
  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      authenticity_token: metaValue('csrf-token'),
      ...body,
    }),
  });

export default { post };
